import { useCallback, useState } from "react";
import { FaInfoCircle } from "react-icons/fa";
import { Toast, ToastBody } from "reactstrap";

export const useToast = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [position, setPosition] = useState("top-right");

  const showToast = useCallback(
    (msg: string, pos: string = "top-right", duration = 5000) => {
      setMessage(msg);
      setPosition(pos);
      setIsOpen(true);
      if (duration > 0) {
        setTimeout(() => setIsOpen(false), duration);
      }
    },
    []
  );

  const hideToast = useCallback(() => setIsOpen(false), []);

  const CustomToast = () => (
    <div className={`fg-toast-container fg-${position}`}>
      <Toast isOpen={isOpen} className="fg-toast">
        <ToastBody>
          <div className="d-flex align-items-start">
            <FaInfoCircle className="fg-toast-icon-warning mr-2" />
            <div className="fg-toast-content">{message}</div>
            <button
              type="button"
              className="ml-auto close fg-toast-close"
              onClick={hideToast}
            >
              <span>&times;</span>
            </button>
          </div>
        </ToastBody>
      </Toast>
    </div>
  );

  return { CustomToast, hideToast, isToastOpen: isOpen, showToast };
};
